var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AccessTokenModal',{attrs:{"open":_vm.showAccessTokenModal},on:{"update:open":function($event){_vm.showAccessTokenModal=$event},"tryToLogin":_vm.tryToLogin}})}
var staticRenderFns = []

export { render, staticRenderFns }